$(document).ready(() =>{

    const $html = $('html');
    $html.css({visibility: "visible"});

    $html.removeAttr("style");

    $('.fancybox').each((index, element) =>
    {
        const $element = $(element);
        $element.fancybox(
            {
                beforeShow : () =>
                {
                    $element[0].title =  $element.data("caption");
                },
                openEffect: "none",
                closeEffect: "none",

                helpers:
                    {
                        overlay:
                            {
                                css: { 'background': 'rgba(236, 236, 236, 0.8)' }
                            }
                    }
            });
    })


    // esc key action
    $(document).keyup((e) =>
    {
        if (e.keyCode === 27)
        { // Esc

            $('#featuredInfoWindow').slideUp(); // hide the faux infowindow on maps 
            $('#protectedDownloadsModal').modal('hide');

            $html.removeClass("search-is-open");
            $html.removeClass("nav-is-open");
            $html.removeClass("aux-nav-is-open");

        }
    });


});
